(function(){
    class SymbolLandAnimator extends PIXI.Container{
        constructor(){
            super();
            this.visible = false;
            this._trackInfo = undefined;
            this._gsapAnimation = null; // Add property to track GSAP animation

            Reflex.registerEventHandler("orientationChange", this.onOrientationChange.bind(this));
            const self = this;
            Reflex.addToUpdate(function (delta, time) { self.update(delta, time); });
        }

        update(){
            if(this._trackInfo){
                const symPos = this._trackInfo.getPosition();
                this.position.set(symPos.x + this._positionOffset.x, symPos.y + this._positionOffset.y);
            }
        }

        play(trackInfo, loop, onCellAnimFinishedCb){
            this._trackInfo = trackInfo;
            this.initialiseSymbolMovie(trackInfo.getPosition(), trackInfo.clipBounds);
            trackInfo.showSymbol(false);

            const self = this;
            
            const playOriginalAnimation = () => {
                this._movie.onComplete = function(){
                    onCellAnimFinishedCb(self);
                }
                this._movie.gotoAndPlay(0);
            };

            if (trackInfo.symbolId === 15) {
                // For bonus symbols, use the overlay symbol instead
                const overlaySymbol = this.getOverlaySymbol(trackInfo.cell.reel, trackInfo.cell.row);
                if (overlaySymbol) {
                    // Show the overlay symbol
                    overlaySymbol.visible = true;

                    if (gameController.bonusSymbolsLanded >= 3 && gameController.spinComplete) {
                        this.playBonusScaleAnimationOnOverlay(overlaySymbol, () => {
                            // Play the movie after scale animation
                            overlaySymbol.playMovie(() => {
                                onCellAnimFinishedCb(self);
                            });
                        });
                    } else {
                        this.playBonusScaleAnimationOnOverlay(overlaySymbol, onCellAnimFinishedCb);
                    }
                } else {
                    playOriginalAnimation();
                }
            } else {
                // For regular symbols, play the original animation
                playOriginalAnimation();
            }
        }

        playBonusScaleAnimationOnOverlay(overlaySymbol, onCellAnimFinishedCb) {
            const self = this;
            
            // Set initial scale
            overlaySymbol.scale.set(1, 1);
            
            // Create GSAP timeline for scale animation on overlay symbol
            const timeline = gsap.timeline({
                onComplete: function() {
                    onCellAnimFinishedCb(self);
                }
            });
            
            // Scale up animation (0.3 seconds)
            timeline.to(overlaySymbol.scale, {
                duration: 0.3,
                x: 1.2,
                y: 1.2,
                ease: "power2.out"
            });
            
            // Scale down animation (0.3 seconds)
            timeline.to(overlaySymbol.scale, {
                duration: 0.3,
                x: 1,
                y: 1,
                ease: "power2.in"
            });
            
            // Store reference to animation for cleanup
            this._gsapAnimation = timeline;
        }

        getOverlaySymbol(reel, row) {
            // Get the overlay symbol from symbolOverlayDisplay
            if (gameController.symbolOverlayDisplay && 
                gameController.symbolOverlayDisplay._panels && 
                gameController.symbolOverlayDisplay._panels[reel] && 
                gameController.symbolOverlayDisplay._panels[reel][row]) {
                return gameController.symbolOverlayDisplay._panels[reel][row].bonus;
            }
            return null;
        }

        initialiseSymbolMovie(symPos, clipBounds){
            this.visible = true;
            this._movie.gotoAndStop(0);
            this.position.set(symPos.x + this._positionOffset.x, symPos.y + this._positionOffset.y);
        }        
        
        cleanupGsapAnimation() {
            if (this._gsapAnimation) {
                this._gsapAnimation.kill();
                this._gsapAnimation = null;
            }
        }

        getTrackInfo(){
            return this._trackInfo;
        }

        finalise() {
            this.visible = false;
            
            // If we were animating a bonus symbol, only clean up the movie, NOT the overlay visibility
            if (this._trackInfo && this._trackInfo.symbolId === 15) {
                const overlaySymbol = this.getOverlaySymbol(this._trackInfo.cell.reel, this._trackInfo.cell.row);
                if (overlaySymbol) {
                    overlaySymbol.hideMovie();
                }
            }
            
            this._trackInfo.showSymbol(true);
            this._trackInfo = undefined;
            this.cleanupGsapAnimation();
        }
        
        untrack(){
            if (this._trackInfo){
                this._trackInfo.untrack();
            }
            this.cleanupGsapAnimation();
        }        
            
        skip() {
            // If there's a GSAP animation running, complete it immediately
            if (this._gsapAnimation) {
                this._gsapAnimation.progress(1);
            }
            this.cleanupGsapAnimation();
            
            // If we were skipping a bonus symbol animation, only clean up the movie
            if (this._trackInfo && this._trackInfo.symbolId === 15) {
                const overlaySymbol = this.getOverlaySymbol(this._trackInfo.cell.reel, this._trackInfo.cell.row);
                if (overlaySymbol) {
                    overlaySymbol.hideMovie();
                }
            }
            
            this.untrack();
        }

        onOrientationChange() {
            if (this._trackInfo !== undefined) {
                let symPos = this._trackInfo.getPosition();
                this.position.set(symPos.x + this._positionOffset.x, symPos.y + this._positionOffset.y);
            }
        }
    }

    let create = function(){
        return new SymbolLandAnimator();
    }

    let initialise = function(json, instance){
        instance._movie = resourceManager.createObject("movie", json.playData.definition, instance.name, {
            definition: json.playData.definition
        });
        instance._movie.loop = false;
        instance._movie.gotoAndStop(0);
        instance._movie.anchor.set(0.5);

        instance._positionOffset = {x:0, y:0 };
        if (json.playData.posOffset){
            instance._positionOffset = json.playData.posOffset;
        }
    }

    let getRequiredFiles = function(){
        return [];
    }

    resourceManager.registerObjectType("symbolLandAnimator", create, initialise, getRequiredFiles);

}());